import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import { SkeletonTheme } from 'react-loading-skeleton'

const App = () => {
  return (
      <I18nProvider>
        <LayoutProvider>
          <SkeletonTheme baseColor="#f3f3f3" highlightColor="#E8E8E8">
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </SkeletonTheme>
        </LayoutProvider>
      </I18nProvider>
  )
}

export {App}
